<script>
export default {
  name: 'NavDrawerLegalLinks',
  computed: {
    hasPrivacyUrl() {
      return this.$te('app.companyPrivacyURL')
    },
    hasTermsUrl() {
      return this.$te('app.companyTermsURL')
    },
    showSeparator() {
      return this.hasPrivacyUrl && this.hasTermsUrl
    },
  },
}
</script>

<template>
  <div v-if="hasPrivacyUrl" class="d-flex align-center justify-start px-4 mb-2">
    <v-btn
      :href="$t('app.companyPrivacyURL')"
      target="_blank"
      text
      small
      class="rounded-lg"
    >
      {{ $t('general.privacyPolicyLinkText') }}
    </v-btn>
    <span v-if="showSeparator" aria-hidden="true">•</span>
    <v-btn
      v-if="hasTermsUrl"
      :href="$t('app.companyTermsURL')"
      target="_blank"
      text
      small
      class="rounded-lg"
    >
      {{ $t('general.termsLinkText') }}
    </v-btn>
  </div>
</template>
